import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils/cn";
import { APP_SHELL_NAV } from "@/lib/moduleManifests";
import { renderModuleIcon } from "@/components/ui/navIcon";

/**
 * IconRail — desktop primary navigation.
 *
 * Per `DESIGN.md §13`: 64px sticky, collapsed only (never expands).
 * Selected state uses `data-active` + `aria-current` (no inline style).
 *
 * Per W2.3 outcome #4 DoD: nav items are imported from
 * `lib/moduleManifests.ts::APP_SHELL_NAV` (single source of truth shared
 * with mobile pill-nav and any future manifest-driven nav surface).
 */
export function IconRail() {
  return (
    <nav
      data-component="IconRail"
      aria-label="主導航"
      className={cn(
        "w-16 sticky top-0 self-start h-screen",
        "flex flex-col items-center gap-2 py-4",
        "bg-paper-deep border-r border-hairline",
      )}
    >
      {APP_SHELL_NAV.map(({ to, icon, label, testId }) => (
        <NavLink
          key={to}
          to={to}
          aria-label={label}
          data-testid={testId}
          className={({ isActive }) =>
            cn(
              "tap-target w-12 h-12 rounded-md flex items-center justify-center",
              "transition-colors duration-quick ease-paper",
              isActive ? "bg-you-tint text-you-strong" : "text-ink-2 hover:bg-black/5",
            )
          }
        >
          {renderModuleIcon(icon, { size: 24 })}
        </NavLink>
      ))}
    </nav>
  );
}
